// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13 1.04492V11H22.9552C22.4796 5.7229 18.2771 1.52047 13 1.04492Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M11 1.04492V13H22.9552C22.45 18.6065 17.7381 23.0001 12 23.0001C5.92487 23.0001 1 18.0752 1 12.0001C1 6.26204 5.3935 1.55015 11 1.04492Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chart-pie-filled')
export default class ChartPieFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-pie-filled',
    }
  }
}
